import { render, staticRenderFns } from "./ProcessWorkPermitDT.vue?vue&type=template&id=59021b16"
import script from "./js/ProcessWorkPermitDT.js?vue&type=script&lang=js&external"
export * from "./js/ProcessWorkPermitDT.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports